import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Comprobante } from 'app/dto/comprobante.dto';
import { ProductoStock } from 'app/dto/producto-stock.dto';
import { TipoComprobante } from 'app/dto/tipo-comprobante.dto';
import { FieldConfig } from 'app/genericForm/field.interface';
import { ProductoStockService } from 'app/service/producto-stock.service';
import { TipoComprobanteService } from 'app/service/tipo-comprobante.service';
import { CargandoService } from 'app/shared/cargando/cargando.service';

@Component({
  selector: 'app-modal-buscador-stock',
  templateUrl: './modal-buscador-stock.component.html',
  styleUrls: ['./modal-buscador-stock.component.scss'],
})
export class ModalBuscadorStockComponent implements OnInit {

  descripcion: string;
  stocks: ProductoStock[];
  @Input() public modalRef: NgbModalRef;
  totalStock = 0;

  formBuscarStock: FieldConfig[]
  constructor(private productoStockService: ProductoStockService, private activeModal: NgbModal,
    private cargandoService: CargandoService) {
  }

  async ngOnInit() {

    this.formBuscarStock = [
      {
        type: "input",
        label: "Buscar por número de pieza de producto",
        inputType: "text",
        name: "descripcionProducto",
        claseGrillaBootstrap: "col-8",
        validations: [
          {
            name: "required",
            validator: Validators.required,
            message: "La descripción del producto es requerida"
          }
        ]
      },
      {
        type: "submit",
        claseGrillaBootstrap: "col-auto float-right",
        label: "Buscar"
      },
      {
        type: "spinner",
        id: "buscador-de-stock",
        claseGrillaBootstrap: "col-auto"
      },
      {
        type: "spinner",
        id: "buscador-de-stock2",
        claseGrillaBootstrap: "col-auto"
      }
    ];
  }

  // submit(formulario: any) {
  //   this.crearVentaService.cliente = formulario.cliente;
  // 	this.router.navigate(["../cargar-venta"], { relativeTo: this.activatedRoute });
  // }
  async buscar(formulario: any) {
    this.cargandoService.start("buscador-de-stock");
    this.stocks = await this.productoStockService.autocomplete(formulario.descripcionProducto).toPromise();
    this.totalStock = this.stocks.map(s => s.unidades).reduce(function (a, b) { return a + b });
    this.cargandoService.stop("buscador-de-stock");
  }

  seleccionarStock(stock: ProductoStock) {
    this.modalRef.close(stock);
  }
}

